cockpitApp.directive('insurance', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/detail/insurance',
    controllerAs: 'insuranceCtrl',
    controller: 'insuranceController'
  };
});
